import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { DougShelfTalkerPostCardBackgroundViewModel } from './doug-shelf-talker-post-card-background-view-model';
import { CardBackgroundComponent } from '../../card-background.component';
import type { GroupedByBrandShelfTalkerCardData } from '../../../../../../../models/shelf-talkers/grouped-by-brand-shelf-talker-card-data';

@Component({
  selector: 'app-doug-shelf-talker-post-card-background',
  templateUrl: './doug-shelf-talker-post-card-background.component.html',
  styleUrls: ['./doug-shelf-talker-post-card-background.component.scss'],
  providers: [DougShelfTalkerPostCardBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DougShelfTalkerPostCardBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public override viewModel: DougShelfTalkerPostCardBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: GroupedByBrandShelfTalkerCardData;
}
